/**
 * 清理文件名，移除中文和特殊字符
 * COS 对中文和特殊字符支持不好，会导致图片无法显示
 * @param fileName 原始文件名
 * @returns 清理后的文件名
 */
export function cleanFileName(fileName: string): string {
  // 获取文件扩展名
  const lastDotIndex = fileName.lastIndexOf('.')
  const name = lastDotIndex > 0 ? fileName.substring(0, lastDotIndex) : fileName
  const ext = lastDotIndex > 0 ? fileName.substring(lastDotIndex) : ''

  // 清理文件名：只保留字母、数字、下划线、短横线
  const cleanName = name
    .replace(/[^\w\-]/g, '_') // 将非字母数字下划线短横线的字符替换为下划线
    .replace(/_+/g, '_') // 多个下划线合并为一个
    .replace(/^_|_$/g, '') // 移除首尾下划线

  // 如果清理后名称为空，使用时间戳
  const finalName = cleanName || Date.now().toString()

  return finalName + ext
}

/**
 * 创建新的 File 对象，使用清理后的文件名
 * @param file 原始 File 对象
 * @returns 新的 File 对象（文件名已清理）
 */
export function createCleanFile(file: File): File {
  const cleanedName = cleanFileName(file.name)
  return new File([file], cleanedName, { type: file.type })
}